import React from 'react'

export const FeatureTabContent = ({ title, subTitle = '', description = null, extraContent = null, featureImage }) => {
  return (
    <div className="row">
      <div className="col-lg-8 details order-2 order-lg-1">
        <h3>{title}</h3>
        <p className="fst-italic">{subTitle}</p>
        <p>{description}</p>
        {extraContent}
      </div>
      <div className="col-lg-4 text-center order-1 order-lg-2">
        <img src={featureImage} alt="Feature" className="img-fluid" />
      </div>
    </div>
  )
}
